<template>
  <div>
    <div class="row">
      <q-select
        class="q-mt-sm col-3"
        :options="options"
        label="Selecione uma Urgencia"
        dense
        outlined
        v-model="urgencia"
        :rules="[(val) => val || 'Campo Obrigatório']"
      />
    </div>
    <empresas-table @empresa="receberEmpresa" />

    <solicitante-table-varios @solicitante="receberSolicitante" />
    <div class="row q-mt-sm">
      <span class="text-bold">Selecionados:</span>
      <span
        class="q-ml-sm"
        v-for="(selecionados, index) in solicitante"
        :key="index"
        >{{ selecionados.name }},</span
      >
    </div>

    <q-btn
      @click="confirmacao = !confirmacao"
      class="q-mt-md"
      icon="add"
      label=" CRIAR NOVO PEDIDO DE COMPRA"
      color="positive"
    />
    <dialog-confirm
      mensagem="Tem certeza que deseja continuar?"
      :exibir="confirmacao"
      :propsClass="'q-pa-md'"
      @resultado="criar"
    >
    </dialog-confirm>
  </div>
</template>

<script>
import EmpresasTable from "./EmpresasTable.vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";
import { ref } from "vue";
import SolicitanteTableVarios from "./SolicitanteTableVarios.vue";
import DialogConfirm from "./DialogConfirm.vue";
import { useRoute } from "vue-router";
export default {
  components: { EmpresasTable, SolicitanteTableVarios, DialogConfirm },
  setup(props, { emit }) {
    const store = useStore();
    const $q = useQuasar();
    const route = useRoute();
    const solicitante = ref("");
    const empresa = ref("");
    const urgencia = ref("");
    const id = route.params.id;
    const confirmacao = ref(false);
    const receberSolicitante = async (value) => {
      solicitante.value = value;
    };

    const receberEmpresa = async (value) => {
      empresa.value = value;
    };

    const criar = async (resultado) => {
      confirmacao.value = false;
      if (!resultado) {
        return;
      }
      if (urgencia.value == "") {
        $q.notify({
          message: "Selecione a urgencia",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }

      let fluxo = [];

      solicitante.value.forEach((e) => {
        fluxo.push({ ...e, user_id: e.id });
      });

      try {
        await store.dispatch("compras/criarNovo", {
          vendor_id: store.state.org.unidadeData.id,
          necessidade_compra_uuid: id,
          provider_id: empresa.value,
          tag_id: urgencia.value.value,
          fluxo_aprovacao: fluxo,
        });

        $q.notify({
          message: "criado com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        emit("voltar");
      } catch (error) {
        $q.notify({
          message: "Erro a o criar",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    return {
      receberSolicitante,
      solicitante,
      empresa,
      receberEmpresa,
      options: [
        {
          label: "Normal",
          value: 1,
        },
        {
          label: "Urgente",
          value: 2,
        },
        {
          label: "Máquina Parada",
          value: 3,
        },
      ],
      urgencia,
      criar,
      confirmacao,
    };
  },
};
</script>

<style></style>
